import React from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import './FailurePage.css';

const logoUrl = 'https://pay.shiroormatha.org/logo.png';

const FailurePage = () => {
  const searchParams = useSearchParams()[0];
  const reason = searchParams.get('reason');
  const Message = searchParams.get('message');


  const getFailureMessage = (reason) => {
    switch (reason) {
      case 'payment_cancelled':
        return 'Payment was cancelled by user.';
      case 'verification_failed':
        return 'Payment verification failed. If amount was debited, it will be refunded.';
      case 'network_error':
        return 'Network error occurred during payment. Please try again.';
      default:
        return 'Payment failed due to an unknown error.';
    }
  };

  const getFailureTitle = (reason) => {
    switch (reason) {
      case 'payment_cancelled':
        return 'Payment Cancelled';
      default:
        return 'Payment Failed';
    }
  };

  return (
    <div className="failure-container">
      <div className="failure-card">
        <div className="page-logo-wrapper">
          <img src={logoUrl} alt="Shiroor Matha" className="page-logo" />
        </div>
        <div className="failure-icon">
          <svg width="80" height="80" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="12" cy="12" r="10" fill="#ef4444"/>
            <path d="m15 9-6 6" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="m9 9 6 6" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </div>
        
        <h1>{getFailureTitle(reason)}</h1>
        <p className="failure-message">
          {getFailureMessage(reason)}
        </p>
        
        <div className="failure-details">
          <div className="detail-item">
            <span className="label">Status:</span>
            <span className="value failure-status">Failed</span>
          </div>
          <div className="detail-item">
            <span className="label">Reason:</span>
           <span className="value">
            {reason
              ? `${reason.split('_').join(' ')}${Message ? ' due to ' + Message : ''}`
              : 'unknown'}
          </span>
          </div>
          <div className="detail-item">
            <span className="label">Time:</span>
            <span className="value">{new Date().toLocaleString()}</span>
          </div>
        </div>
        
        <div className="actions">
          <Link to="https://shiroormatha.org/sevas" className="retry-button">
            Try Again
          </Link>
          <button 
            className="support-button"
            onClick={() => window.location.href = 'mailto:support@example.com?subject=Payment Failed'}
          >
            Contact Support
          </button>
        </div>
        
        <div className="note">
          <p>
            <strong>Note:</strong> If money was debited from your account, 
            it will be automatically refunded within 5-7 business days. 
            For any queries, please contact our support team.
          </p>
        </div>
      </div>
    </div>
  );
};

export default FailurePage;
